import router from '@_system/router/index.js'
// const getObjByIndex = function(payload) {
// 	let index = payload.index
// 	let arr = payload.arr
// 	for (let i = 0; i < arr.length; i++) {
// 		if (index == arr[i].index) {
// 			return arr[i]
// 		}
// 	}
// }

var state = {
	router: router,
	tabs: []
}


const mutations = {
	delTab(state, payload) {
		let path = payload.path
		let tabs = state.tabs
		let index = 0
		for (let i = 0; tabs.length; i++) {
			if (path === tabs[i].path) {
				index = i
				break
			}
		}
		state.router.currentRoute.meta.timeStamp = new Date().getTime()
		let deltab = tabs.splice(index, 1)
		if (deltab[0].active) {
			state.router.push(tabs[tabs.length - 1].path)
		}

	},
	activeTabs(state, payload) {
		let buff = false
		let path = payload.path
		state.tabs.forEach((item) => {
			if (item.path == path) {
				buff = true
				item.active = true
			} else {
				item.active = false
			}
		})
		if (!buff) {
			state.tabs.push({
				title: state.router.currentRoute.name,
				path: state.router.currentRoute.path,
				active: true
			})
		}
	},

	closeAll(state) {
		let mainRoute = this.getters['main/getMainRoute']
		for (let i = 0; i < mainRoute.children.length; i++) {
			if (mainRoute.children[i].path != state.tabs[0].path) {
				mainRoute.children[i].meta.timeStamp = Math.random()
			}
		}
		state.tabs = [state.tabs[0]]
		state.router.push(state.tabs[0].path)
	},
	closeOther(state, payload) {
		let path = payload.path
		let tabs = state.tabs
		let index = 0
		for (let i = 0; tabs.length; i++) {
			if (path === tabs[i].path) {
				index = i
				break
			}
		}
		let mainRoute = this.getters['main/getMainRoute']
		for (let i = 0; i < mainRoute.children.length; i++) {
			if (mainRoute.children[i].path != state.tabs[0].path && mainRoute.children[i].path != state.tabs[index].path) {
				mainRoute.children[i].meta.timeStamp = Math.random()
			}
		}
		state.tabs = [state.tabs[0], state.tabs[index]]
		state.router.push(state.tabs[1].path)


	},
}

const actions = {
	// setcurrentActive (context,payload) {
	//   context.commit('demo',payload)
	// }
}
const getters = {
	getMainRoute(state) {
		let routes = state.router.options.routes
		for (let i = 0; i < routes.length; i++) {
			if (routes[i].name == 'main') {
				return routes[i]
			}
		}
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
